var render, staticRenderFns
import script from "./Set2FA.vue?vue&type=script&lang=js"
export * from "./Set2FA.vue?vue&type=script&lang=js"
import style0 from "./Set2FA.vue?vue&type=style&index=0&id=fded5228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports